/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type GridMessagingActivitySummaryQueryVariables = {
    dateFrom: unknown;
    sendAtFrom: unknown;
    dateTo: unknown;
};
export type GridMessagingActivitySummaryQueryResponse = {
    readonly " $fragmentRefs": FragmentRefs<"CardMessagingActivitySent_Query" | "CardMessagingActivityUndelivered_Query" | "CardMessagingActivityReceived_Query" | "CardMessagingActivityQueued_Query">;
};
export type GridMessagingActivitySummaryQuery = {
    readonly response: GridMessagingActivitySummaryQueryResponse;
    readonly variables: GridMessagingActivitySummaryQueryVariables;
};



/*
query GridMessagingActivitySummaryQuery(
  $dateFrom: Date!
  $sendAtFrom: Date!
  $dateTo: Date!
) {
  ...CardMessagingActivitySent_Query_sa9LS
  ...CardMessagingActivityUndelivered_Query_sa9LS
  ...CardMessagingActivityReceived_Query_sa9LS
  ...CardMessagingActivityQueued_Query_1At4t6
}

fragment CardMessagingActivityQueued_Query_1At4t6 on Query {
  queuedCount: reminderCount(filter: {_operators: {status: {in: [sent, scheduled, pending]}, sendAt: {gte: $sendAtFrom, lte: $dateTo}}})
}

fragment CardMessagingActivityReceived_Query_sa9LS on Query {
  receivedCount: messageCount(filter: {type: inbound, _operators: {createdAt: {gte: $dateFrom, lte: $dateTo}}})
}

fragment CardMessagingActivitySent_Query_sa9LS on Query {
  sentCount: messageCount(filter: {type: outbound, _operators: {status: {in: [opened, delivered, sent, pending]}, createdAt: {gte: $dateFrom, lte: $dateTo}, ref: {nin: [chatAudit, chatAuditTz]}}})
}

fragment CardMessagingActivityUndelivered_Query_sa9LS on Query {
  undeliveredCount: messageCount(filter: {status: undelivered, _operators: {createdAt: {gte: $dateFrom, lte: $dateTo}}})
}
*/

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "dateFrom"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "dateTo"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sendAtFrom"
},
v3 = [
  {
    "kind": "Variable",
    "name": "createdAtFrom",
    "variableName": "dateFrom"
  },
  {
    "kind": "Variable",
    "name": "createdAtTo",
    "variableName": "dateTo"
  }
],
v4 = {
  "kind": "Variable",
  "name": "lte",
  "variableName": "dateTo"
},
v5 = {
  "fields": [
    {
      "kind": "Variable",
      "name": "gte",
      "variableName": "dateFrom"
    },
    (v4/*: any*/)
  ],
  "kind": "ObjectValue",
  "name": "createdAt"
},
v6 = {
  "fields": [
    (v5/*: any*/)
  ],
  "kind": "ObjectValue",
  "name": "_operators"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "GridMessagingActivitySummaryQuery",
    "selections": [
      {
        "args": (v3/*: any*/),
        "kind": "FragmentSpread",
        "name": "CardMessagingActivitySent_Query"
      },
      {
        "args": (v3/*: any*/),
        "kind": "FragmentSpread",
        "name": "CardMessagingActivityUndelivered_Query"
      },
      {
        "args": (v3/*: any*/),
        "kind": "FragmentSpread",
        "name": "CardMessagingActivityReceived_Query"
      },
      {
        "args": [
          {
            "kind": "Variable",
            "name": "sendAtFrom",
            "variableName": "sendAtFrom"
          },
          {
            "kind": "Variable",
            "name": "sendAtTo",
            "variableName": "dateTo"
          }
        ],
        "kind": "FragmentSpread",
        "name": "CardMessagingActivityQueued_Query"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "GridMessagingActivitySummaryQuery",
    "selections": [
      {
        "alias": "sentCount",
        "args": [
          {
            "fields": [
              {
                "fields": [
                  (v5/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "ref",
                    "value": {
                      "nin": [
                        "chatAudit",
                        "chatAuditTz"
                      ]
                    }
                  },
                  {
                    "kind": "Literal",
                    "name": "status",
                    "value": {
                      "in": [
                        "opened",
                        "delivered",
                        "sent",
                        "pending"
                      ]
                    }
                  }
                ],
                "kind": "ObjectValue",
                "name": "_operators"
              },
              {
                "kind": "Literal",
                "name": "type",
                "value": "outbound"
              }
            ],
            "kind": "ObjectValue",
            "name": "filter"
          }
        ],
        "kind": "ScalarField",
        "name": "messageCount",
        "storageKey": null
      },
      {
        "alias": "undeliveredCount",
        "args": [
          {
            "fields": [
              (v6/*: any*/),
              {
                "kind": "Literal",
                "name": "status",
                "value": "undelivered"
              }
            ],
            "kind": "ObjectValue",
            "name": "filter"
          }
        ],
        "kind": "ScalarField",
        "name": "messageCount",
        "storageKey": null
      },
      {
        "alias": "receivedCount",
        "args": [
          {
            "fields": [
              (v6/*: any*/),
              {
                "kind": "Literal",
                "name": "type",
                "value": "inbound"
              }
            ],
            "kind": "ObjectValue",
            "name": "filter"
          }
        ],
        "kind": "ScalarField",
        "name": "messageCount",
        "storageKey": null
      },
      {
        "alias": "queuedCount",
        "args": [
          {
            "fields": [
              {
                "fields": [
                  {
                    "fields": [
                      {
                        "kind": "Variable",
                        "name": "gte",
                        "variableName": "sendAtFrom"
                      },
                      (v4/*: any*/)
                    ],
                    "kind": "ObjectValue",
                    "name": "sendAt"
                  },
                  {
                    "kind": "Literal",
                    "name": "status",
                    "value": {
                      "in": [
                        "sent",
                        "scheduled",
                        "pending"
                      ]
                    }
                  }
                ],
                "kind": "ObjectValue",
                "name": "_operators"
              }
            ],
            "kind": "ObjectValue",
            "name": "filter"
          }
        ],
        "kind": "ScalarField",
        "name": "reminderCount",
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "330084541d6df519a4ef5bcde9eae3f3",
    "id": null,
    "metadata": {},
    "name": "GridMessagingActivitySummaryQuery",
    "operationKind": "query",
    "text": "query GridMessagingActivitySummaryQuery(\n  $dateFrom: Date!\n  $sendAtFrom: Date!\n  $dateTo: Date!\n) {\n  ...CardMessagingActivitySent_Query_sa9LS\n  ...CardMessagingActivityUndelivered_Query_sa9LS\n  ...CardMessagingActivityReceived_Query_sa9LS\n  ...CardMessagingActivityQueued_Query_1At4t6\n}\n\nfragment CardMessagingActivityQueued_Query_1At4t6 on Query {\n  queuedCount: reminderCount(filter: {_operators: {status: {in: [sent, scheduled, pending]}, sendAt: {gte: $sendAtFrom, lte: $dateTo}}})\n}\n\nfragment CardMessagingActivityReceived_Query_sa9LS on Query {\n  receivedCount: messageCount(filter: {type: inbound, _operators: {createdAt: {gte: $dateFrom, lte: $dateTo}}})\n}\n\nfragment CardMessagingActivitySent_Query_sa9LS on Query {\n  sentCount: messageCount(filter: {type: outbound, _operators: {status: {in: [opened, delivered, sent, pending]}, createdAt: {gte: $dateFrom, lte: $dateTo}, ref: {nin: [chatAudit, chatAuditTz]}}})\n}\n\nfragment CardMessagingActivityUndelivered_Query_sa9LS on Query {\n  undeliveredCount: messageCount(filter: {status: undelivered, _operators: {createdAt: {gte: $dateFrom, lte: $dateTo}}})\n}\n"
  }
};
})();
(node as any).hash = 'bc934b85be29635e0800765e87002e9a';
export default node;
